(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  // Variables globales
  let isScrolling = false;
  let scrollTimeout = null;
  
  // Calculate header heights for sticky positioning
  function calculateHeaderHeights() {
    const root = document.documentElement;
    const top = document.querySelector('.header-top');
    const main = document.querySelector('.header-main');
    const nav = document.querySelector('.header-nav');
    
    if (top && main && nav) {
      root.style.setProperty('--header-top-height', top.offsetHeight + 'px');
      root.style.setProperty('--header-main-height', main.offsetHeight + 'px');
      root.style.setProperty('--header-nav-height', nav.offsetHeight + 'px');
      root.style.setProperty('--header-height', (top.offsetHeight + main.offsetHeight + nav.offsetHeight) + 'px');
    }
  }
  
  // Gestionnaire de scroll optimisé et autres fonctions
  function handleScroll() {
    if (isScrolling) return;
    isScrolling = true;
    
    requestAnimationFrame(() => {
      const root = document.documentElement;
      const top = document.querySelector('.header-top');
      const main = document.querySelector('.header-main');
      const nav = document.querySelector('.header-nav');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      const topHeight = top ? top.offsetHeight : 0;
      
      // Sticky header logic
      if (scrollTop > topHeight) {
        root.classList.add('sticky-header');
        main.classList.add('shrink');
        
        if (nav) {
          nav.style.top = main.offsetHeight + 'px';
        }
      } else {
        root.classList.remove('sticky-header');
        main.classList.remove('shrink');
        if (nav) {
          nav.style.top = '';
        }
      }
      
      // Progressive effects
      if (scrollTop > topHeight / 2 && scrollTop <= topHeight) {
        const progress = (scrollTop - (topHeight / 2)) / (topHeight / 2);
        main.style.transform = `translateY(${-progress * 10}px)`;
        main.style.opacity = 1 - (progress * 0.2);
      } else {
        main.style.transform = 'translateY(0)';
        main.style.opacity = 1;
      }
      
      isScrolling = false;
    });
  }
  
  // Highlighting active menu item based on URL
  function setActiveMenuItem() {
    const currentPath = window.location.pathname;
    const menuItems = document.querySelectorAll('.primary-menu__link');
    
    menuItems.forEach(item => {
      const href = item.getAttribute('href');
      if (href && currentPath.indexOf(href) === 0 && href !== '/') {
        item.classList.add('active');
      }
    });
  }
  
  // === MEGA MENU GAP FIXED - VERSION CORRIGÉE COMPLÈTE ===
  function initMegaMenus() {
    const menuItems = document.querySelectorAll('.primary-menu__item');
    const overlay = document.querySelector('.menu-overlay');
    let currentOpenMenu = null;
    let isTransitioning = false;
    const isMobile = window.innerWidth <= 768;
    
  
    
    menuItems.forEach(item => {
      const megaMenu = item.querySelector('.mega-submenu');
      
      if (megaMenu) {
        let hoverTimeout;
        
        // Desktop: hover events
        if (!isMobile) {
          item.addEventListener('mouseenter', function() {
            if (isTransitioning) return;
            clearTimeout(hoverTimeout);
            openMegaMenu(item, megaMenu);
          });
          
          item.addEventListener('mouseleave', function() {
            hoverTimeout = setTimeout(() => {
              if (!item.matches(':hover')) {
                closeMegaMenu(item);
              }
            }, 150);
          });
        } else {
          // Mobile: click events
          const link = item.querySelector('.primary-menu__link');
          link.addEventListener('click', function(e) {
            e.preventDefault();
            toggleMegaMenu(item);
          });
        }
        
        // Gestion optimisée des clics sur liens
        megaMenu.addEventListener('click', function(e) {
          if (e.target.tagName === 'A' && e.target.href && !e.target.href.includes('#')) {
            handleMenuLinkClick(item, e.target, e);
          }
        });
        
        // Maintenir le menu ouvert si on survole le mega menu
        megaMenu.addEventListener('mouseenter', function() {
          clearTimeout(hoverTimeout);
        });
        
        megaMenu.addEventListener('mouseleave', function() {
          if (!isMobile) {
            closeMegaMenu(item);
          }
        });
      }
    });
    
    // Fonctions d'ouverture/fermeture FINALES
    function openMegaMenu(item, megaMenu) {
      if (item.classList.contains('menu-open')) return;
      
      // Fermer les autres menus
      closeOtherMenus(item);
      
      // Ouvrir le menu actuel
      item.classList.add('menu-open');
      currentOpenMenu = item;
      
      // Activer overlay sur mobile
      if (isMobile && overlay) {
        overlay.classList.add('active');
      }
      
      // Debug final - vérification gap + largeur
      setTimeout(() => {
        const navRect = document.querySelector('.header-nav').getBoundingClientRect();
        const menuRect = megaMenu.getBoundingClientRect();
        const isSticky = document.body.classList.contains('sticky-header');
        
        // Vérifier le gap (doit être proche de -1px)
        const gap = menuRect.top - navRect.bottom;
        
        // Vérifier la largeur pleine écran
        const fullWidth = Math.abs(menuRect.width - window.innerWidth) < 10;
        const centered = Math.abs(menuRect.left) < 10 && Math.abs(menuRect.right - window.innerWidth) < 10;
        
       
        
        
      }, 100);
      
      
    }
    
    function closeMegaMenu(item) {
      if (!item.classList.contains('menu-open')) return;
      
      // Animation de fermeture rapide
      item.classList.add('menu-closing');
      item.classList.remove('menu-open');
      
      setTimeout(() => {
        item.classList.remove('menu-closing');
      }, 200);
      
      // Désactiver overlay
      if (overlay) {
        overlay.classList.remove('active');
      }
      
      if (currentOpenMenu === item) {
        currentOpenMenu = null;
      }
      
     
    }
    
    function closeOtherMenus(excludeItem) {
      menuItems.forEach(item => {
        if (item !== excludeItem && item.classList.contains('menu-open')) {
          closeMegaMenu(item);
        }
      });
    }
    
    function closeAllMenus() {
      menuItems.forEach(item => closeMegaMenu(item));
    }
    
    function toggleMegaMenu(item) {
      if (item.classList.contains('menu-open')) {
        closeMegaMenu(item);
      } else {
        openMegaMenu(item, item.querySelector('.mega-submenu'));
      }
    }
    
    // Gestion optimisée du clic sur lien
    function handleMenuLinkClick(menuItem, linkElement, event) {
      const href = linkElement.getAttribute('href');
      
      if (!href || href === '#' || href.startsWith('javascript:')) {
        return;
      }
      
      
      
      // Empêcher la navigation par défaut temporairement
      event.preventDefault();
      
      // Marquer comme en transition
      isTransitioning = true;
      
      // Fermeture immédiate + feedback visuel
      menuItem.classList.add('menu-closing');
      menuItem.classList.remove('menu-open');
      
      // Feedback visuel sur le lien cliqué
      linkElement.classList.add('clicked');
      linkElement.style.background = 'rgba(255, 107, 53, 0.1)';
      linkElement.style.color = '#FF6B35';
      linkElement.style.transform = 'scale(0.98)';
      
      // Ajouter classe de chargement à la page
      document.body.classList.add('page-loading');
      
      // Navigation avec délai minimal pour UX
      setTimeout(() => {
        window.location.href = href;
      }, 100);
      
      // Timeout de sécurité pour réinitialiser
      setTimeout(() => {
        document.body.classList.remove('page-loading');
        isTransitioning = false;
        linkElement.classList.remove('clicked');
        linkElement.style.background = '';
        linkElement.style.color = '';
        linkElement.style.transform = '';
      }, 3000);
    }
    
    // Fermeture au clic externe
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.primary-menu__item') && currentOpenMenu) {
        closeMegaMenu(currentOpenMenu);
      }
    });
    
    // Fermeture avec Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && currentOpenMenu) {
        closeMegaMenu(currentOpenMenu);
      }
    });
    
    // Overlay click sur mobile
    if (overlay) {
      overlay.addEventListener('click', () => closeAllMenus());
    }
    
    // Gestion du redimensionnement avec recalcul position
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Fermer tous les menus sur resize pour éviter les problèmes de position
        closeAllMenus();
        
        // Recalculer les hauteurs pour position fixed
        calculateHeaderHeights();
        
        
      }, 250);
    });
    
    
  }
  
  // Animation du compteur de panier - mise à jour pour nouvelle structure
  function animateCartCount() {
    const cartCounts = document.querySelectorAll('.cart-count-external');
    cartCounts.forEach(cartCount => {
      if (cartCount) {
        const currentCount = parseInt(cartCount.textContent) || 0;
        if (currentCount > 0) {
          cartCount.style.animation = 'none';
          cartCount.offsetHeight; // Trigger reflow
          cartCount.style.animation = 'cartPulse 2s infinite';
        } else {
          cartCount.style.display = 'none';
        }
      }
    });
  }
  
  // Update cart count dynamically
  function updateCartCount(count) {
    const cartCounts = document.querySelectorAll('.cart-count-external');
    cartCounts.forEach(cartCount => {
      cartCount.textContent = count;
      cartCount.setAttribute('data-count', count);
      if (count > 0) {
        cartCount.style.display = 'flex';
        animateCartCount();
      } else {
        cartCount.style.display = 'none';
      }
    });
  }
  
  // Recherche intelligente (simulation)
  function initSmartSearch() {
    const searchInput = document.querySelector('.search-container input');
    const searchButton = document.querySelector('.search-container button');
    
    if (searchInput && searchButton) {
      let searchTimeout;
      
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        
        searchTimeout = setTimeout(() => {
          const query = this.value.trim();
          if (query.length > 2) {
            // Ici vous pouvez ajouter la logique de suggestions
            
          }
        }, 300);
      });
      
      // Animation du bouton de recherche
      searchButton.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-50%) scale(1.1) rotate(5deg)';
      });
      
      searchButton.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(-50%) scale(1) rotate(0deg)';
      });
    }
  }
  
  // Set current language in selector - GÉRÉ AUTOMATIQUEMENT PAR SHOPIFY
  // function setCurrentLanguage() { ... } - Supprimé car natif
  
  // Optimisation des performances
  function throttle(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Initialize everything
  window.addEventListener('DOMContentLoaded', function() {
    calculateHeaderHeights();
    setActiveMenuItem();
    // setCurrentLanguage(); - Supprimé : géré automatiquement par Shopify
    // initLanguageSelector(); - Supprimé : utilise le natif Shopify
    initMegaMenus();
    animateCartCount();
    initSmartSearch();
    
    // FIX Z-INDEX : Créer un portal pour le menu langue
    createLanguagePortal();
    
    // Throttled scroll handler
    const throttledScroll = throttle(handleScroll, 16); // 60fps
    window.addEventListener('scroll', throttledScroll);
    
    // Listen for cart updates (Shopify theme events)
    document.addEventListener('cart:updated', function(event) {
      if (event.detail && event.detail.cart) {
        updateCartCount(event.detail.cart.item_count);
      }
    });
  });
  
  // Fonction pour créer un portal et résoudre le problème de z-index
  function createLanguagePortal() {
    const languageOptions = document.querySelector('.language-options');
    const languageDropdown = document.querySelector('.language-dropdown');
    
    if (languageOptions && languageDropdown) {
      // Créer un container portal dans le body
      const portal = document.createElement('div');
      portal.id = 'language-portal';
      portal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 999999999;
      `;
      document.body.appendChild(portal);
      
      // Cloner le menu et l'ajouter au portal
      const clonedOptions = languageOptions.cloneNode(true);
      clonedOptions.style.pointerEvents = 'auto';
      portal.appendChild(clonedOptions);
      
      // Cacher l'original
      languageOptions.style.display = 'none';
      
      // Gérer l'ouverture/fermeture
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            if (languageDropdown.hasAttribute('open')) {
              portal.style.display = 'block';
              clonedOptions.style.opacity = '1';
              clonedOptions.style.visibility = 'visible';
              clonedOptions.style.transform = 'translateY(0) scale(1)';
            } else {
              clonedOptions.style.opacity = '0';
              clonedOptions.style.visibility = 'hidden';
              clonedOptions.style.transform = 'translateY(-10px) scale(0.95)';
              setTimeout(() => {
                portal.style.display = 'none';
              }, 200);
            }
          }
        });
      });
      
      observer.observe(languageDropdown, { attributes: true });
      
      
    }
  }
  
  window.addEventListener('resize', throttle(() => {
    calculateHeaderHeights();
    // Réinitialiser les menus sur resize pour éviter les problèmes
    const menuItems = document.querySelectorAll('.primary-menu__item');
    menuItems.forEach(item => {
      item.classList.remove('menu-open', 'menu-closing');
    });
    initMegaMenus(); // Recalculate menu positions
  }, 250));
  
  // Preload des ressources critiques
  const preloadCSS = document.createElement('link');
  preloadCSS.rel = 'preload';
  preloadCSS.as = 'style';
  preloadCSS.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap';
  document.head.appendChild(preloadCSS);
  
  // Expose functions for external use
  window.DistriotHeader = {
    updateCartCount: updateCartCount
    // setCurrentLanguage: setCurrentLanguage - Supprimé : géré par Shopify natif
  };
  
  
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partenaires"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const partnerCards = document.querySelectorAll('.partner-card');

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animationPlayState = 'running';
      }
    });
  }, observerOptions);

  partnerCards.forEach(card => {
    observer.observe(card);
  });

  const partnerImages = document.querySelectorAll('.partner-image');
  partnerImages.forEach(img => {
    if (img.tagName === 'IMG') {
      img.addEventListener('error', function() {
        this.style.display = 'none';
        const placeholder = document.createElement('div');
        placeholder.className = 'partner-image';
        placeholder.style.cssText = 'background:#f1f5f9;display:flex;align-items:center;justify-content:center;color:#94a3b8;';
        placeholder.innerHTML =
          '<svg width="60" height="60" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">' +
            '<path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd"></path>' +
          '</svg>';
        this.parentNode.insertBefore(placeholder, this);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
